var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"st__block1"},[_c('div',{staticClass:"st__header"},[_c('div',{staticClass:"st__title"},[_c('div',{staticClass:"st__text"},[_c('h5',[_vm._v(_vm._s(_vm.itemData.title))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }